/**
 * Cyphon Categories Carousel
 * Provides smooth arrow navigation and dynamic disabled states for sections/cy-categories.liquid
 */
(() => {
  const initCategories = () => {
    document.querySelectorAll('[data-cy-cat]').forEach((section) => {
      if (section.dataset.cyCatInit === 'true') return;
      section.dataset.cyCatInit = 'true';

      const track = section.querySelector('.cy-cat__track');
      if (!track) return;

      const prevBtn = section.querySelector('.cy-cat__arrow[data-dir="-1"]');
      const nextBtn = section.querySelector('.cy-cat__arrow[data-dir="1"]');

      const updateArrows = () => {
        if (!prevBtn && !nextBtn) return;
        const scrollLeft = track.scrollLeft;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const isScrollable = maxScroll > 4;

        if (prevBtn) {
          const isAtStart = !isScrollable || scrollLeft <= 4;
          prevBtn.disabled = isAtStart;
          prevBtn.setAttribute('aria-disabled', isAtStart ? 'true' : 'false');
        }

        if (nextBtn) {
          const isAtEnd = !isScrollable || scrollLeft >= maxScroll - 4;
          nextBtn.disabled = isAtEnd;
          nextBtn.setAttribute('aria-disabled', isAtEnd ? 'true' : 'false');
        }
      };

      const getScrollDistance = () => {
        const item = track.querySelector('.cy-cat__item');
        if (!item) return 300;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 16;
        return item.getBoundingClientRect().width + gap;
      };

      section.addEventListener('click', (e) => {
        const btn = e.target.closest('.cy-cat__arrow');
        if (!btn || btn.disabled) return;

        const dir = parseInt(btn.dataset.dir, 10) || 1;
        const amount = getScrollDistance();
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        track.scrollBy({
          left: amount * dir,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      });

      // Throttled scroll listener
      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              updateArrows();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );

      // Keyboard left/right arrow navigation
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
        }
      });

      // Update states on window resize
      window.addEventListener('resize', updateArrows, { passive: true });

      // Initial check
      updateArrows();
      // Second check after images or layout settlement
      setTimeout(updateArrows, 150);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategories);
  } else {
    initCategories();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', initCategories);
})();
